import React from 'react';

import PartnerLogosEnhanced from './partner-logos-enhanced';
import withWindowResize from '../../ui/components/window-resize';
import { buildFilterFromUrl, filterLogos } from '../../vwa/util';
import { withError } from '../components/error-boundary';

import './footer-logo.less';

const FooterLogo = ({ logos, width, breakpoint, className, location }) => {
    if (!logos || logos.length < 1) return null;
    if (!isNaN(breakpoint) && width >= breakpoint) return null;

    let displayLogos = logos;
    if (location) {
        const [prePath, locationRest] = location.pathname.split('vwa/');
        const [locationSlug, path] = (locationRest || '').split('/');
        const filters = buildFilterFromUrl(path || '');
        displayLogos = filterLogos(filters, logos);
    }

    return (
        <div className={`footerLogo${className ? ` ${className}` : ''}`}>
            <PartnerLogosEnhanced footer logos={displayLogos} />
        </div>
    );
};

export default withError(withWindowResize(FooterLogo));
